/** 過濾訊息分類 - 身分 */
export enum NotificationType {
  /** 系統公告 */
  SystemAnnouncement = 'N01',
  /** 權限異動通知 */
  PermissionChange = 'N02',
  /** 優惠訊息 */
  DiscountMessage = 'N03',
  /** 活動通知" */
  EventNotification = 'N04',
  /** 獎項指派 */
  AwardAssignment = 'N05',
  /** 收回通知 */
  RevocationNotice = 'N06',
  /** 獎項審核通知 */
  AwardReviewNotification = 'N07',
  /** 獎項審核通知 */
  AwardExpirationNotice = 'N08',
  /** 獎項入帳通知 */
  AwardDepositNotification = 'N09',
  /** 獎項到期通知 */
  PointExpirationNotice = 'N10',
  /** 點數入帳通知 */
  PointDepositNotification = 'N11',
  /** 點數異動通知 */
  PointChangeNotification = 'N12'
}
